import store from './store/index'
import order from './order/index'
import goods from './goods/index'
export default [...store, ...order, ...goods]
